import angular from 'angular'
import * as _ from 'lodash'
import { hasPermission } from '../services/permission'

export default ['$q', 'locklessService', authorizationService]

function authorizationService($q, locklessService) {
  /*
   * Replaces,
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/publishActions/publishActions.controller.js#L96
   */
  this.canPublish = function canPublish(storyObj) {
    const defer = $q.defer()

    locklessService
      .loadUserRolesAuth()
      .then(function loadUserRolesAuthSuccess(userRolesAuth) {
        // uber is used to signify a super-power.
        const uberPublicationAllowed = hasPermission(
          window.userRolesAuth.story.publish,
          storyObj.canonical_website
        )
        const initialPublicationAllowed =
          uberPublicationAllowed ||
          hasPermission(
            window.userRolesAuth.story.initialPublish,
            storyObj.canonical_website
          )
        const subsequentPublicationAllowed =
          uberPublicationAllowed ||
          hasPermission(
            window.userRolesAuth.story.subsequentPublish,
            storyObj.canonical_website
          )
        const message = { message: 'Unauthorized to Publish' }

        if (uberPublicationAllowed) {
          defer.resolve({})
        } else if (
          angular.isDefined(initialPublicationAllowed) &&
          angular.isDefined(subsequentPublicationAllowed)
        ) {
          defer.resolve({})
        } else {
          defer.reject(message)
        }
      })
      .catch(function loadUserRolesAuthError(error) {
        defer.reject(error)
      })
    return defer.promise
  }
  /*
   * Replaces,
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/publishActions/publishActions.controller.js#L118
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/publishActions/publishActions.controller.js#L107
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/services/publish.js#L36
   */
  this.canSchedulePublication = function canSchedulePublication(storyObj) {
    const defer = $q.defer()
    locklessService
      .loadUserRolesAuth()
      .then(function loadUserRolesAuthSuccess(userRolesAuth) {
        const uberPublicationAllowed = hasPermission(
          window.userRolesAuth.story.publish,
          storyObj.canonical_website
        )
        const initialPublicationAllowed =
          uberPublicationAllowed ||
          hasPermission(
            window.userRolesAuth.story.initialPublish,
            storyObj.canonical_website
          )
        const subsequentPublicationAllowed =
          uberPublicationAllowed ||
          hasPermission(
            window.userRolesAuth.story.subsequentPublish,
            storyObj.canonical_website
          )
        const orgPublicationAllowed = _.get(
          userRolesAuth,
          'org.schedule_publish'
        )
        const message = { message: 'Unauthorized to Schedule Publication' }

        const canPublish =
          orgPublicationAllowed &&
          (uberPublicationAllowed ||
            initialPublicationAllowed ||
            subsequentPublicationAllowed)
        if (canPublish) {
          defer.resolve({})
        } else {
          defer.reject(message)
        }
      })
      .catch(function loadUserRolesAuthError(error) {
        defer.reject(error)
      })
    return defer.promise
  }
}
